import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PortalIcon, normalizePortalText } from 'utils/baochauTheme';

const IconCollapse = styled.span`
  transform: ${(props) => (props.open ? 'rotate(180deg)' : '')};
  color: ${(props) => (props.open ? '#ed3237' : '')};
`;

const BWAccordion = ({
  className,
  style,
  title,
  children,
  id,
  hideCollapse,
  isRequired = false,
  componentCustom,
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const handleAccordion = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleTitleClick = (event) => {
    if (hideCollapse) {
      return;
    }

    const interactiveElement = event.target.closest(
      'a, button, input, textarea, select, [role="button"], [data-no-collapse]',
    );

    if (interactiveElement && interactiveElement !== event.currentTarget) {
      return;
    }

    handleAccordion();
  };

  const handleTitleKeyDown = (event) => {
    if (hideCollapse || !['Enter', ' '].includes(event.key)) {
      return;
    }

    event.preventDefault();
    handleAccordion();
  };

  return (
    <React.Fragment>
      <div id={id} className={`bw_items_frm${className ? ` ${className}` : ''}`}>
        <div className={`bw_collapse ${open ? 'bw_active' : ''}`}>
          <div
            className={`bw_collapse_title ${!hideCollapse ? 'bw_collapse_title_clickable' : ''}`}
            style={style}
            role={!hideCollapse ? 'button' : undefined}
            tabIndex={!hideCollapse ? 0 : undefined}
            aria-expanded={!hideCollapse ? open : undefined}
            onClick={handleTitleClick}
            onKeyDown={handleTitleKeyDown}>
            {!hideCollapse ? (
              <IconCollapse open={open}>
                <PortalIcon icon='fi fi-rr-angle-small-down' className='bw_collapse_icon' />
              </IconCollapse>
            ) : null}
            <h3>
              {typeof title === 'string' ? normalizePortalText(title) : title}
              {isRequired && <span className='bw_red'>*</span>}
            </h3>
          </div>
          {open && <div className='bw_collapse_panel'>{children}</div>}
          {componentCustom && componentCustom}
        </div>
      </div>
    </React.Fragment>
  );
};

BWAccordion.propTypes = {
  isRequired: PropTypes.bool,
  title: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default BWAccordion;
